// Updates inside Cody's Android app (Josh 10-18; docs/flows/android-auto-update.yaml › flavors.phone): a Mac's ⋯ gets
// an Updates… tile beside Devices… that opens the phone's Updates (its own update, Canary builds, its watch's update),
// with the phone's one-line state under its name. Only when the phone's bridge is there — `window.CodyPhoneUpdates`,
// the direct flavor's PhoneUpdatesBridge.kt: {op:'watch'} → {line} now and on every change; {op:'open'}. A browser and
// the play flavor have no bridge: no tile.
import { registerHomeItem } from '../../core/home-items.js'

export const ITEM = { id: 'phoneupdates', label: 'Updates…', symbol: 'lucide:circle-arrow-down', needs: '', section: 'mac', order: 25.5 }

/// The tile for this page: null without the bridge; else the item (its `line` the phone's last word, `open` the bridge).
export function phoneUpdatesItem(bridge = globalThis.CodyPhoneUpdates, onLine = () => {}) {
  if (typeof bridge?.postMessage !== 'function') return null
  const st = { line: '' }
  const say = (op) => { try { bridge.postMessage(JSON.stringify({ op })) } catch {} }
  bridge.addEventListener?.('message', (e) => {
    try { const m = JSON.parse(e?.data ?? '{}'); if (typeof m.line === 'string') { st.line = m.line; onLine(m.line) } } catch {}
  })
  say('watch')
  return { ...ITEM, line: () => st.line, open: () => say('open') }
}

const item = phoneUpdatesItem()
if (item) registerHomeItem(item)
